// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"701716e1","667":"bd6b9b00","977":"8d6a8a17"}[chunkId] + ".chunk.js";
};